import React, { useContext, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { StoreContext } from "../../../contexts";
import { ACTIONS } from "../../../store";
import PageTitle from "../../atoms/PageTitle";
import Layout from "../../templates/Layout";
import { PAGE_TITLES } from "../../../constants";
import Loader from "../../atoms/Loader";
import cs from "classnames";
import classes from "./ArchivedSubmissions.module.scss";
import VideoSubmissionItem from "../WritingCompetition/components/VideoSubmissionItem";
import classesWritingCompetition from "../WritingCompetition/WritingCompetition.module.scss";
import { matchesSearchTerm } from "../WritingCompetition/WritingCompetition";
import SearchBar from "../WritingCompetition/components/SearchBar";

const submissionColors = [
  "#87BA48",
  "#FFDE59",
  "#FF666B",
  "#FFAE43",
  "#F472D0",
  "#6EC887",
  "#49BEBC",
  "#B29367",
  "#0097B2",
];

const ArchivedSubmissions = observer(() => {
  const { writingcompetition } = useContext(StoreContext);
  const [searchTerm, setSearchTerm] = useState("");

  const getAction = ACTIONS.WRITING_COMPETITON.GET_ARCHIVED_SUBMISSIONS;

  useEffect(() => {
    // Get edition from URL params if needed, or default to 1
    const urlParams = new URLSearchParams(window.location.search);
    const edition = urlParams.get("edition") || 1;

    writingcompetition[`${getAction}`](edition);
  }, []);

  const archivedData = writingcompetition.archivedSubmissions;
  
  console.log(archivedData, 'archivedData');

  // Filter video submissions based on search term
  const allVideoSubmissions = archivedData?.video_submissions || [];
  const videoSubmissions = allVideoSubmissions.filter((submission) =>
    matchesSearchTerm(submission, searchTerm)
  );

  return (
    <>
      <PageTitle value={PAGE_TITLES.WRITINNG_COMPETITION} />
      <Layout logotype="maor">
        <div className="bg-white">
          <div className="wrapper-m pt-10 pb-10">
            {writingcompetition[`isLoading${getAction}`] ? (
              <div className="wrapper-vertical-m">
                <Loader />
              </div>
            ) : (
              <div className={cs(classesWritingCompetition.SubmissionContainer)}>
                <h2
                  className={cs(
                    classesWritingCompetition.submissionHeader,
                    classesWritingCompetition.grandstanderFamily
                  )}
                >
                  <span className={cs(classesWritingCompetition.submissionHeaderText)}>
                    Archived Submissions
                  </span>
                  <div className={classesWritingCompetition.submissionHeaderLineWrapper}>
                    <div className={classesWritingCompetition.submissionHeaderLine}></div>
                  </div>
                </h2>
                
                {/* Search Bar */}
                {allVideoSubmissions.length > 0 && (
                  <SearchBar
                    placeholder="Search by name"
                    value={searchTerm}
                    onChange={setSearchTerm}
                  />
                )}

                {videoSubmissions.length > 0 ? (
                  <div
                    className={`${cs(classesWritingCompetition.grid)} ${cs(
                      classesWritingCompetition.gridSm
                    )} ${cs(classesWritingCompetition.gridLg)}`}
                  >
                    {videoSubmissions.map((script, index) => {
                      const playerBgColor = submissionColors[index % 9];
                      return (
                        <VideoSubmissionItem
                          key={script.id || index}
                          script={script}
                          playerBgColor={playerBgColor}
                          handleWelcomeModal={() => {}}
                          judgesInSession={true}
                        />
                      );
                    })}
                  </div>
                ) : searchTerm ? (
                  <div className={cs(classesWritingCompetition.noResultsMessage)}>
                    <p>No submissions found matching {searchTerm}</p>
                  </div>
                ) : (
                  <div className={cs(classes.noSubmissionsMessage)}>
                    <p>No archived submissions found.</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </Layout>
    </>
  );
});

export default ArchivedSubmissions;
